module.exports = __webpack_public_path__ + "img/install-unknown-apps.e1f9805e.webp";